module.exports = __webpack_public_path__ + "img/f2.2eceb2c0.png";